// removed by extract-text-webpack-plugin
module.exports = {"spin":"_3ho8ferhm4vucl24RAlNjf"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/Input/TreeSelection/styles.scss
// module id = 960
// module chunks = 18